import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../../lib/LanguageContext';

const ABOUT_IMG = 'https://customer-assets-agu9un31.emergentagent.net/job_costa-blanca-trust/artifacts/ui0hqhci_WhatsApp%20Image%202026-07-14%20at%2017.00.46.webp';

export const WhoWeAre = () => {
  const { t } = useLanguage();

  const handleScroll = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="about" data-testid="about-section" className="pt-10 md:pt-12 pb-16 md:pb-20 bg-cream relative overflow-hidden">
      <div className="absolute inset-0 -z-10 opacity-60">
        <div className="absolute top-10 right-0 w-[50%] h-[50%] bg-gradient-to-bl from-sand-100 to-transparent" />
        <div className="absolute bottom-0 left-0 w-[40%] h-[40%] bg-gradient-to-tr from-olive-300/15 to-transparent" />
      </div>

      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-ink-900 leading-[0.95] mb-8">
          {t.about.title}
        </h2>

        <div className="mb-12">
          <div className="font-serif text-2xl md:text-3xl text-ink-900 italic">{t.about.signature}</div>
          <div className="text-xs uppercase tracking-[0.24em] text-ink-500 mt-2">{t.about.signatureRole}</div>
        </div>

        <div
          data-testid="about-photo"
          className="relative w-full max-w-md mx-auto aspect-[3/4] mb-14 rounded-sm overflow-hidden shadow-[0_24px_60px_rgba(45,51,47,0.14)]"
        >
          <img
            src={ABOUT_IMG}
            alt="Luuk en Kika, oprichters van Casa Serena"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>

        <div className="space-y-6 text-left md:text-center mb-12">
          {t.about.paragraphs.map((p, i) => (
            <p
              key={i}
              data-testid={`about-paragraph-${i}`}
              className="text-base md:text-lg text-ink-700 leading-relaxed"
            >
              {p}
            </p>
          ))}
        </div>

        <button
          type="button"
          data-testid="about-cta-button"
          onClick={handleScroll}
          className="group inline-flex items-center gap-3 px-8 py-4 bg-ink-900 text-cream rounded-sm text-sm tracking-wide hover:bg-sand-600 transition-colors"
        >
          {t.about.button}
          <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </button>
      </div>
    </section>
  );
};

export default WhoWeAre;
